import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deleteDevice = defineEndpoint({
  method: 'DELETE',
  path: '/v1/devices/:deviceId',
  params: z.object({ deviceId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
